import React from 'react'
import styles from './HeroProjectSection.module.css'

/* Swap each `image` with your own (R2 / CDN / local import).
   `layout: 'wide' | 'tall'` controls the image proportion.
   Pass a custom list via prop: <HeroProjectSection projects={...} /> */
const PROJECTS = [
  {
    title: 'Annual Leadership Summit, Pune',
    category: 'Conferences',
    image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1600&q=80',
    layout: 'wide',
    href: '#work',
  },
  {
    title: 'Flagship Product Launch, Mumbai',
    category: 'Product Launches',
    image: 'https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=1400&q=80',
    layout: 'tall',
    href: '#work',
  },
]

const HeroProjectSection = ({ projects = PROJECTS }) => {
  return (
    <section id="work" className={styles.section}>
      <div className={styles.container}>
        <header className={styles.head}>
          <span className={styles.eyebrow}>Projects</span>
          <h2 className={styles.heading}>
            Take a glimpse at the experiences we&apos;ve proudly crafted to
            perfection
          </h2>
        </header>

        <div className={styles.projects}>
          {projects.map((p) => (
            <a
              key={p.title}
              href={p.href}
              className={`${styles.project} ${p.layout === 'tall' ? styles.tall : styles.wide}`}
            >
              <div className={styles.media}>
                <img src={p.image} alt={p.title} className={styles.image} />
              </div>
              <div className={styles.caption}>
                <span className={styles.title}>{p.title}</span>
                <span className={styles.category}>{p.category}</span>
              </div>
            </a>
          ))}
        </div>

        {/* <div className={styles.footer}>
          <a href="#work" className={styles.viewAll}>
            View All Projects
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div> */}
      </div>
    </section>
  )
}

export default HeroProjectSection